export function PageHeader({ eyebrow, title, description, actions, testid }) {
  return (
    <div className="mb-10 flex flex-col gap-6 border-b border-amber-900/30 pb-8 md:flex-row md:items-end md:justify-between" data-testid={testid}>
      <div className="max-w-2xl">
        {eyebrow && <p className="eyebrow mb-3">{eyebrow}</p>}
        <h1 className="font-heading text-3xl font-bold tracking-tight text-amber-100 sm:text-4xl">{title}</h1>
        {description && <p className="mt-3 text-sm text-slate-400 md:text-base">{description}</p>}
      </div>
      {actions && <div className="flex flex-wrap gap-3">{actions}</div>}
    </div>
  );
}

export function EmptyState({ icon: Icon, title, children, testid = "empty-state" }) {
  return (
    <div className="rounded-xl border border-dashed border-amber-900/40 bg-[#121620]/60 px-6 py-16 text-center" data-testid={testid}>
      {Icon && <Icon className="mx-auto mb-4 h-8 w-8 text-amber-500/60" aria-hidden />}
      <p className="font-heading text-lg text-amber-100">{title}</p>
      {children && <div className="mt-2 text-sm text-slate-400">{children}</div>}
    </div>
  );
}

export function Pager({ page, pageSize, total, onChange, testid = "pager" }) {
  const pages = Math.max(1, Math.ceil(total / pageSize));
  if (pages <= 1) return null;
  return (
    <div className="mt-10 flex items-center justify-center gap-4 font-mono text-xs uppercase tracking-widest text-slate-400" data-testid={testid}>
      <button className="btn-ghost" disabled={page <= 1} onClick={() => onChange(page - 1)} data-testid={`${testid}-prev`}>
        Prev
      </button>
      <span data-testid={`${testid}-status`}>
        {page} / {pages}
      </span>
      <button className="btn-ghost" disabled={page >= pages} onClick={() => onChange(page + 1)} data-testid={`${testid}-next`}>
        Next
      </button>
    </div>
  );
}
